module.exports = __webpack_public_path__ + "static/media/italianriveria.38199044.png";